import React from "react";
import { View, StyleSheet, FlatList } from "react-native";

import { hasItems } from "../../../../helpers/utils";
import Goal from "./Goal";
import AddNewGoal from "./AddNewGoal";

export default function GoalsList(props) {
  const { controller, goals, showPresets = true } = props;

  return (
    <View style={styles.container}>
      {hasItems(goals) ? (
        <>
          <FlatList
            style={styles.list}
            keyExtractor={(item) => item.resolution_id}
            data={goals}
            renderItem={({ item }) => (
              <Goal controller={controller} goal={item} {...props} />
            )}
          />

          {showPresets ? (
            <AddNewGoal controller={controller} {...props} />
          ) : null}
        </>
      ) : showPresets ? (
        <AddNewGoal controller={controller} />
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    position: "relative",
    zIndex: 11,
  },
  list: {
    paddingHorizontal: 8,
  },
});
